// components/FitnessStats.js

import moment from "moment"
import React from "react"

const FitnessStatsTable = ({ data }) => {

  const formatDuration = duration => {
    if (!duration) return "00:00:00"

    // If it's already in HH:MM:SS format, just return it
    if (typeof duration === "string" && duration.includes(":")) {
      const parts = duration.split(":").map(Number)
      if (parts.length === 2)
        return `${parts[0].toString().padStart(2, "0")}:${parts[1]
          .toString()
          .padStart(2, "0")}`
      if (parts.length === 3)
        return parts.map(v => v.toString().padStart(2, "0")).join(":")
    }

    // If it's a number, assume it's in seconds
    const totalSeconds = Number(duration)
    if (isNaN(totalSeconds)) return "00:00:00"

    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = Math.floor(totalSeconds % 60)

    return [
      hours.toString().padStart(2, "0"),
      minutes.toString().padStart(2, "0"),
      seconds.toString().padStart(2, "0"),
    ].join(":")
  }

  return (
    <div
      className=""
      style={{
        height: "280px",
        overflowY: "auto",
        scrollbarWidth: "thin",
      }}
    >
      <div className="table-responsive">
        <table className="table table-sm table-bordered text-center">
          <thead className="table-light fs-6">
            <tr>
              <th>Date</th>
              <th>Workout Name</th>
              <th>Duration</th>
              <th>Distance (mi)</th>
              <th>Max Heart Rate</th>
              <th>Avg Heart Rate</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr key={index}>
                <td>{moment(item?.date).format("DD-MM-YYYY")}</td>
                <td>{item?.type}</td>
                <td>{formatDuration(item?.duration)} Hrs</td>
                <td>{item?.distance || 0} Miles</td>
                <td>{item?.max_heartrate || 0} bpm</td>
                <td>{item?.avg_heartrate || 0} bpm</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default FitnessStatsTable
